/**
 *
 * TopGreenHeader
 *
 */
import { Button, cn } from '@heltarchat/ui';
import { NewP } from 'app/components/AlltypeStyledComponent';
import React, { memo } from 'react';
import styled from 'styled-components';
import StyledComponentProps from 'utils/types/styled-components-type';
import { X } from 'lucide-react';

interface Props {
  headerTitle: string;
  onClick: (e: any) => void;
  backgroundColor?: string;
  crossIconColor?: string;
}

interface TopShadcnHeaderProps {
  headerTitle: string;
  onClose: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  variant?:
    | 'default'
    | 'destructive'
    | 'outline'
    | 'secondary'
    | 'ghost'
    | 'link';
}

export function TopShadcnHeader({
  headerTitle,
  onClose,
  className,
  variant = 'outline',
}: TopShadcnHeaderProps) {
  return (
    <header
      className={cn('flex items-center justify-between py-4 px-4', className)}
    >
      <h1 className='text-2xl font-bold'>{headerTitle}</h1>
      <Button
        variant={variant}
        size='icon'
        onClick={onClose}
        className='ml-4 !btn-heltar-outline2'
      >
        <X className='h-5 w-5' />
      </Button>
    </header>
  );
}

export const TopGreenHeader = memo((props: Props) => {
  return (
    <Div backgroundcolor={props.backgroundColor}>
      <NewP
        color='var(--heltar-text-on-brand)'
        fontsize='17px'
        margin='auto 10px'
      >
        {props.headerTitle}
      </NewP>
      <NewP
        color={props.crossIconColor ?? 'var(--heltar-text-on-brand)'}
        fontsize='20px'
        margin='auto 10px auto auto'
        cursor='pointer'
        onClick={props.onClick}
      >
        &#x2715;
      </NewP>
    </Div>
  );
});

const Div = styled.div<StyledComponentProps>`
  width: 100%;
  height: 55px;
  background-color: ${props =>
    props.backgroundcolor || 'var(--heltar-brand-primary)'};
  display: flex;
  position: relative;
`;
